// extracted by mini-css-extract-plugin
export default {"textWrapper":"FMI2coNPuKXCGpRtxe8B","qrCode":"P9TN9moFYhNvXnxbgGeg","linkButton":"NsQLBA9mabq2xaNQjNsN","disabled":"u914ReaNDjv82FM0qGBb"};